import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CustomersTemplate } from 'components/Templates'

const Customers: FC = () => {
  return (
    <Layout headline={'お客さまリスト'} iconPath={'/icon/white/face.svg'} title={'お客さまリスト'}>
      <CustomersTemplate />
    </Layout>
  )
}
export default Customers
